import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParamsContext } from '../../contexts/ParamsContext';
import { useClientsContext } from './Context';
import MessageForm from './MessageForm';
import { UserX } from 'lucide-react';

interface MessageViewProps {
    forcePushOnly?: boolean;
    forcePushEmailOnly?: boolean;
    forceAll?: boolean;
}

const MessageView = ({
    forcePushOnly = false,
    forcePushEmailOnly = false,
    forceAll = false,
}: MessageViewProps) => {
    const { id } = useParamsContext();
    const { data: clients, loading, loadClients } = useClientsContext();
    const navigate = useNavigate();

    useEffect(() => {
        // Garante que os clientes sejam carregados se a lista estiver vazia
        if (clients.length === 0) {
            loadClients();
        }
    }, []);

    const client = forceAll ? undefined : clients.find((c) => c.uid === id);
    const isPushOnly = forcePushOnly;
    const isPushEmailOnly = forcePushEmailOnly || (!isPushOnly && !!client);

    const handleBack = () => {
        navigate(client ? `/clientes?id=${client.uid}` : '/clientes');
    };

    if (loading && !client) {
        return (
            <div className="mx-auto w-full max-w-2xl space-y-3 px-2" aria-busy="true">
                <div className="sf-skeleton h-14" />
                <div className="sf-skeleton h-40" />
            </div>
        );
    }

    // Sem destinatario, o envio seria para todos: so o fluxo explicito de envio em massa pode seguir.
    if (!forceAll && !client) {
        return (
            <div className="sf-state">
                <UserX aria-hidden />
                <h2>Cliente não encontrado</h2>
                <p>Não foi possível identificar o destinatário desta mensagem.</p>
                <button type="button" className="sf-link" onClick={handleBack}>
                    Voltar para clientes
                </button>
            </div>
        );
    }

    return (
        <div className="mx-auto w-full max-w-2xl px-2">
            <MessageForm
                uid={client?.uid}
                displayName={client?.displayName}
                photoURL={client?.photoURL}
                pushOnly={isPushOnly}
                pushEmailOnly={isPushEmailOnly}
                cancel={handleBack}
            />
        </div>
    );
};

export default MessageView;
